import LoadingSpin from "components/Loading spins/LoadingSpin";
import { RouteName } from "constant/routeNames";
import { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { setLiveTVSuccess, setVideoStart } from "redux/VideoPlayerRedux";
import LiveTVService from "services/liveTv/LiveTVService";
import TvGuide from "./liveTVPlayerPage/TvGuide";
import VideoPlayerInsideLiveTV from "./liveTVPlayerPage/VideoPlayerInsideLiveTV";
import YouAreWatching from "./liveTVPlayerPage/YouAreWatching";
import LazyLoadImg from "components/LazyLoadImg";
import TvChannelSkeleton from "components/skeleton/TvChannelSkeleton";
import TvChannelSmallCardSkeleton from "components/skeleton/TvChannelSmallCardSkeleton";
import BannerSkeleton from "components/skeleton/BannerSkeleton";
import { Adsense } from "@ctrl/react-adsense";
import GeneralServices from "services/General/GeneralServices";
import { FaFacebookF, FaWhatsapp, FaLink, FaCrown } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";

function LiveTvHomeWithPlayer() {
  const loggedInUser = useSelector((state: any) => state?.user?.currentUser);
  const { currentLiveTv } = useSelector((state: any) => state?.video);
  const navigate = useNavigate();
  const dispatch = useDispatch<any>();
  const { slug } = useParams();
  const [banners, setBanners] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState("");
  const [dataList, setDataList] = useState<any[]>([]);
  const [gAdSlot, setgAdSlot] = useState<any>();
  const [subscriptionEnabled, setSubscriptionEnabled] = useState<any>();
  const [gAdSlotHoriz, setgAdSlotHoriz] = useState<any>();
  const FE_URL = process.env.REACT_APP_FRONTEND_URL;
  useEffect(() => {
    GeneralServices.getAllConfigData()
      .then((res) => {
        const PageStatus = res?.data?.filter(
          (item: any) =>
            item?.title === "is_livetv_gAd" && item?.value !== null,
        );
        if (PageStatus[0]?.value === "1") {
          const filteredData = res?.data?.filter(
            (item: any) => item?.title === "gAdSquSlot" && item?.value !== null,
          );
          const filteredHoriz = res?.data?.filter(
            (item: any) => item?.title === "gAdSlot" && item?.value !== null,
          );
          setgAdSlot(filteredData[0]?.value);
          setgAdSlotHoriz(filteredHoriz[0]?.value);
          console.log("setgAdStatus", filteredData[0]?.value);
        }
        const SubsStatus = res?.data?.filter(
          (item: any) =>
            item?.title === "subscription_enabled" && item?.value !== null,
        );
        if (SubsStatus?.[0]?.value === "1") {
          setSubscriptionEnabled(SubsStatus[0]?.value);
        }
      })
      .catch((e) => {});
  }, []);

  useEffect(() => {
    let cleanedSlug = slug && slug.endsWith(".html") ? slug.slice(0, -5) : slug;

    const loadChannelData = async () => {
      setLoading(true);
      setTimeout(async () => {
        await LiveTVService.getCHannelDetailsBySlug(cleanedSlug)
          .then((res) => {
            dispatch(setVideoStart());

            const obg = {
              ...res.data,
              vast_tag_url:
                res.data?.vast_tag_url &&
                res.data?.vast_tag_url.replace(/&amp;/g, "&"),
            };
            console.log(obg);
            dispatch(setLiveTVSuccess(obg));
            setLoading(false);
          })
          .catch((err) => {
            toast.error("Content Not Found");
            setError("Content Not Found");
            navigate(RouteName.pageNotFound);
          });
      }, 1000);
    };
    loadChannelData();
  }, [slug]);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  //Banners
  useEffect(() => {
    LiveTVService.getTVChannelBanner().then((res) => {
      setBanners(res.data);
    });
  }, []);

  const navigateBack = () => {
    navigate(RouteName.Home);
  };

  // modern channel info card (shared by both branches)
  const ChannelInfoCard = () =>
    !loading ? (
      <div className="h-auto w-[88%] flex-col rounded-2xl border border-white/10 bg-white/[0.04] p-4 backdrop-blur-md cursor-default max-sm:w-full">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="h-11 w-11 overflow-hidden rounded-lg ring-1 ring-white/10">
              <LazyLoadImg
                imgSrc={currentLiveTv?.thumbnail}
                imgAlt={"Card pic"}
                imgHeight={"100%"}
                imgWidth={"100%"}
                wrapperProps={{
                  style: {
                    width: "100%",
                    height: "100%",
                    display: "inline-block",
                  },
                }}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  borderRadius: "5px",
                }}
              />
            </div>
            <p className="text-[14px] font-semibold text-white">
              {currentLiveTv?.channel_number}
            </p>
          </div>

          <p className="rounded-full bg-[var(--red)]/15 px-2.5 py-1 text-[11px] font-semibold uppercase tracking-wide text-[var(--red)]">
            {currentLiveTv?.category}
          </p>
        </div>
        <p
          dangerouslySetInnerHTML={{
            __html: currentLiveTv?.description,
          }}
          className="mt-4 w-full text-[13px] font-normal leading-relaxed text-white/75 max-sm:w-full"
        />
      </div>
    ) : (
      <TvChannelSmallCardSkeleton />
    );

  const shareUrl = encodeURIComponent(
    `${FE_URL}/live-tv/${currentLiveTv?.slug ?? ""}`,
  );

  const copyLink = () => {
    navigator.clipboard
      ?.writeText(`${FE_URL}/live-tv/${currentLiveTv?.slug ?? ""}`)
      .then(() => toast.success("Link copied to clipboard"))
      .catch(() => {});
  };

  // extra detail-panel content
  const ChannelSidePanel = () =>
    !loading ? (
      <div className="mt-5 w-[88%] space-y-4 max-sm:w-full">
        {/* status chips */}
        <div className="flex flex-wrap gap-2">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-[var(--red)]/15 px-3 py-1 text-[11px] font-semibold uppercase tracking-wide text-[var(--red)]">
            <span className="h-2 w-2 animate-pulse rounded-full bg-[var(--red)]" />
            Live
          </span>
          {currentLiveTv?.stream_label && (
            <span className="rounded-full bg-white/10 px-3 py-1 text-[11px] font-semibold uppercase tracking-wide text-white">
              {currentLiveTv?.stream_label}
            </span>
          )}
          <span className="rounded-full bg-white/10 px-3 py-1 text-[11px] font-semibold uppercase tracking-wide text-white">
            {currentLiveTv?.plan_id === 2 ? "Premium" : "Free to Watch"}
          </span>
        </div>

        {/* share */}
        <div className="rounded-2xl border border-white/10 bg-white/[0.04] p-4 backdrop-blur-md">
          <p className="mb-3 text-[12px] font-semibold uppercase tracking-[0.12em] text-gray-400">
            Share this channel
          </p>
          <div className="flex items-center gap-3">
            <a
              target="_blank"
              rel="noreferrer"
              href={`https://www.facebook.com/sharer/sharer.php?u=${shareUrl}`}
              className="flex h-10 w-10 items-center justify-center rounded-full bg-white/5 text-white transition-colors hover:bg-white/15"
            >
              <FaFacebookF className="text-[14px]" />
            </a>
            <a
              target="_blank"
              rel="noreferrer"
              href={`https://twitter.com/intent/tweet?url=${shareUrl}`}
              className="flex h-10 w-10 items-center justify-center rounded-full bg-white/5 text-white transition-colors hover:bg-white/15"
            >
              <FaXTwitter className="text-[14px]" />
            </a>
            <a
              target="_blank"
              rel="noreferrer"
              href={`https://wa.me/?text=${shareUrl}`}
              className="flex h-10 w-10 items-center justify-center rounded-full bg-white/5 text-white transition-colors hover:bg-white/15"
            >
              <FaWhatsapp className="text-[15px]" />
            </a>
            <button
              onClick={copyLink}
              className="flex h-10 w-10 items-center justify-center rounded-full bg-white/5 text-white transition-colors hover:bg-white/15"
            >
              <FaLink className="text-[14px]" />
            </button>
          </div>
        </div>

        {subscriptionEnabled === "1" &&
          loggedInUser?.role !== "plus_subscription" && (
            <div className="relative overflow-hidden rounded-2xl border border-[var(--red)]/30 bg-gradient-to-br from-[var(--red)]/15 to-transparent p-5">
              <div className="mb-2 flex h-9 w-9 items-center justify-center rounded-full bg-[var(--red)]/20 text-[var(--red)]">
                <FaCrown className="text-[15px]" />
              </div>
              <h4 className="text-[15px] font-bold text-white">Go Premium</h4>
              <p className="mt-1 text-[12px] leading-relaxed text-white/70">
                Unlock exclusive channels, ad-free streaming, and HD on every
                device.
              </p>
              <Link
                to={RouteName.SubscriptionPlanRoute}
                className="mt-4 inline-flex rounded-full bg-[var(--red)] px-5 py-2 text-[13px] font-semibold text-white shadow-lg shadow-[var(--red)]/30 transition-all duration-300 hover:scale-[1.03] hover:brightness-110"
              >
                Explore Plans
              </Link>
            </div>
          )}
      </div>
    ) : null;

  return (
    <>
      <Helmet>
        <title>
          {currentLiveTv && currentLiveTv?.seo_title
            ? `${currentLiveTv && currentLiveTv?.seo_title}`
            : `${currentLiveTv && currentLiveTv?.name}`}
        </title>
        <meta
          name="title"
          content={currentLiveTv && currentLiveTv?.seo_title}
        />
        <meta
          name="description"
          content={currentLiveTv && currentLiveTv?.meta_description}
        />
        <meta
          name="keywords"
          content={currentLiveTv && currentLiveTv?.focus_keyword}
        />
        <meta
          name="keywords"
          content={currentLiveTv && currentLiveTv?.focus_keyword}
        />

        <link
          rel="canonical"
          href={`${FE_URL}/live-tv/${currentLiveTv && currentLiveTv?.slug}`}
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content={currentLiveTv && currentLiveTv?.name}
        />
        <meta
          name="twitter:description"
          content={currentLiveTv && currentLiveTv?.meta_description}
        />
        <meta
          name="twitter:image"
          content={currentLiveTv && currentLiveTv?.thumbnail}
        />

        <meta
          property="og:title"
          content={currentLiveTv && currentLiveTv?.name}
        />
        <meta
          property="og:description"
          content={currentLiveTv && currentLiveTv?.meta_description}
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content={`${FE_URL}/live-tv/${currentLiveTv && currentLiveTv?.slug}`}
        />
        <meta
          property="og:image"
          content={currentLiveTv && currentLiveTv?.thumbnail}
        />
      </Helmet>

      {banners?.length > 0 ? (
        <>
          <div className="flex justify-between max-sm:block">
            <div className="mb-5 flex w-[90%] justify-center sm:-ml-28 max-sm:ml-0 max-sm:block max-sm:w-full">
              {!loading ? (
                <VideoPlayerInsideLiveTV />
              ) : (
                <div className="flex justify-center max-sm:h-[200px]">
                  <div className="flex items-center">
                    <LoadingSpin fontSize={"60px"} color={"#f30543"} />
                  </div>
                </div>
              )}
              <div className="sm:hidden max-sm:mt-5">
                <YouAreWatching
                  currentLiveTv={currentLiveTv}
                  dataList={dataList}
                />
              </div>
            </div>
            <div className="ml-[-50px] flex w-[35%] flex-col justify-between max-sm:ml-0 max-sm:flex max-sm:w-full max-sm:gap-3">
              <div className="flex flex-col">
                {/* Description and Details */}
                <ChannelInfoCard />
                <ChannelSidePanel />
              </div>

              {gAdSlot && (
                <div className="mb-[20px] flex w-[85%] justify-center max-sm:my-3 max-sm:mt-0 max-sm:w-full">
                  <Adsense
                    client="ca-pub-5773929890067376"
                    slot={gAdSlot}
                    style={{
                      display: "block",
                      marginBottom: "10px",
                      height: "90px",
                      justifyContent: "center",
                    }}
                    layout="in-article"
                    data-full-width-responsive="true"
                    data-ad-format="auto"
                  />
                </div>
              )}
            </div>
          </div>
          <div className="flex w-[65%] items-center justify-center max-sm:hidden">
            <YouAreWatching currentLiveTv={currentLiveTv} dataList={dataList} />
          </div>
        </>
      ) : (
        <>
          <div className="flex justify-between max-sm:block">
            <div className="mb-5 flex w-[90%] justify-center sm:-ml-28 max-sm:ml-0 max-sm:block max-sm:w-full">
              {!loading ? (
                <VideoPlayerInsideLiveTV />
              ) : (
                <div className="flex items-center justify-center max-md:mt-32 md:max-h-screen">
                  <div className="mt-[-100px] flex items-center max-sm:h-[200px]">
                    <LoadingSpin fontSize={"60px"} color={"#f30543"} />
                  </div>
                </div>
              )}
              <div className="sm:hidden max-sm:mt-5">
                <YouAreWatching
                  currentLiveTv={currentLiveTv}
                  dataList={dataList}
                />
              </div>
            </div>
            <div className="ml-[-50px] flex w-[35%] flex-col max-sm:ml-0 max-sm:flex max-sm:w-full max-sm:gap-3">
              <div className="flex flex-col">
                {/* Description and Details */}
                <ChannelInfoCard />
                <ChannelSidePanel />
              </div>
              {gAdSlot && (
                <div className="mb-[20px] mt-[40px] flex w-[88%] justify-center max-sm:my-3 max-sm:mt-0 max-sm:w-full">
                  <Adsense
                    client="ca-pub-5773929890067376"
                    slot={gAdSlot}
                    style={{
                      display: "block",
                      marginBottom: "10px",
                      height: "90px",
                      justifyContent: "center",
                    }}
                    layout="in-article"
                    data-full-width-responsive="true"
                    data-ad-format="auto"
                  />
                </div>
              )}
            </div>
          </div>
          <div className="flex w-[65%] items-center justify-center max-sm:hidden">
            <YouAreWatching currentLiveTv={currentLiveTv} dataList={dataList} />
          </div>
        </>
      )}

      <div className="w-[65%] items-center justify-center max-sm:w-full">
        {gAdSlotHoriz && (
          <Adsense
            client="ca-pub-5773929890067376"
            slot={gAdSlotHoriz}
            style={{
              display: "flex",
              marginBottom: "20px",
              marginTop: "20px",
              height: "90px",
              justifyContent: "center",
            }}
            format="horizontal"
            data-full-width-responsive="true"
          />
        )}
      </div>
      {/* show playing now channel */}

      <TvGuide setDataList={setDataList} />
    </>
  );
}

export default LiveTvHomeWithPlayer;
